<template>
  <div>
    <div v-if="loading" class="over container">
      <div class="row" style="height: 45vh">
        <div class="col-12"></div>
      </div>
      <div class="row">
        <div class="spinner-border text-primary center" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="over container d-flex">
        <div class="myModal p-2 container row">
          <!-- ********************BAR DU MENU *********************** -->
          <div class="row align-items-center justify-content-center m-0 logoBar">
            <div class="logo d-flex justify-content-center col-4">
              <img src="../../../static/img/13.png" alt="" />
            </div>
            <a
              href="https://ul.waze.com/ul?ll=32.65695440%2C35.41763663&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location">
              <img class="m-3 wazeImage" src="../../../static/img/waze.png" alt="" />
            </a>
            <!-- <div
              class="d-flex justify-content-center languageChoice col-4"
              @click="changeLanguage"
            >
              {{ buttonText }}
            </div>
           -->
          </div>
          <!-- ********************TITRE *********************** -->
          <div class="row align-items-center justify-content-center align-self-center" style="height: 35%">
            <div class="col-12 text-center justify-content-center center" style="color: #3369bc" id="titleMainPage">
              {{ lang }} {{ title }}
            </div>
            <div class="subTitle col-8 text-center" @click="moveToOtherPath">
              {{ translation.longPath }}
            </div>
            <div class="col-7 text-center justify-content-center center stampGame" id="stampGame"
              @click="moveToOtherPath">
              <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5" />
              </svg>
              {{ translation.stamp }}
            </div>
          </div>
          <!-- ********************USERNAME 25%*********************** -->
          <div class="row align-items-center" style="height: 25%">
            <div class="col-12">
              <div class="py-3">
                <input name="userName" label="Pseudo" id="userName" v-model="userName" required placeholder="השם שלך"
                  class="center fullWidth text-center" style="color: black; border: solid 2px #3369bc; height: 56px" />
              </div>
            </div>
          </div>
          <!-- ********************EXPLICATION OU COMMENCE LE JEU  10%*********************** -->
          <div class="row align-items-center" style="height: 10%">
            <div class="col-12 d-flex justify-content-center">
              <div class="p-2 h5 text-center rtl blur" style="max-width: 360px; color: white">
                <div class="rtl font-weight-bold">
                  {{ translation.beware }}
                </div>
                <div class="mt-2 font-weight-bold">
                  {{ translation.startPoint }}
                </div>
              </div>
            </div>
          </div>
          <!-- ********************BOTTOM BAR*********************** -->
          <div class="row align-items-center justify-content-center bottomBar m-0">
            <div class="startButton d-flex justify-content-center" @click="checkIfName()">
              <img src="../../../static/img/step.png" alt="" style="height: 60px; position: relative; top: 10px" />
            </div>
            <div class="startText">
              {{ translation.letsGoButton }}
            </div>
          </div>
        </div>
      </div>

      <!-- ********************POP UP PAS DE NOM *********************** -->
      <div v-if="showAlertNoName === true" class="over center">
        <div class="p-3 myModal2" style="background-color: #3369bc; color: white">
          <div class="mt-3 text-center">
            <div class="mt-3 rtl" style="font-family: 'noot', cursive; font-size: 40px">
              {{ translation.oups }}...
            </div>
            <div class="mt-3 text-center">{{ translation.noPassword }}</div>
          </div>
          <button class="btn btn-primary btn-lg btn3d fullWidth font-weight-bold my-4"
            style="min-height: 60px; width: 80%" @click="showAlertNoName = false">
            {{ translation.gotIt }}
          </button>
          <!-- <div class="font-weight-bold mt-5 mb-2 h4 text-center">
            {{ translation.gotIt }}
          </div> -->
        </div>
      </div>

      <!-- ********************EXPLICATION AVANT LE COMPTE A REBOURD QUI INDIQUE QU'IL FAUT ACCEPTER LA GEOLOCALISATION ********************** -->
      <div v-if="confirmName === true && permissionStatus == 'prompt'" class="over center">
        <div class="p-3 myModal2" style="background-color: #3369bc; color: white; margin-top: 10vh">
          <img src="../../../static/img/omerFlirting.gif" class="happyGif" alt="" />

          <div class="mt-3 text-center">
            <div class="rtl beware text-center">
              {{ translation.beware }}
              <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" fill="currentColor"
                class="bi bi-heart-fill" viewBox="0 0 16 16" style="color: red; position: relative; left: -4px">
                <path fill-rule="evenodd"
                  d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
              </svg>
            </div>
            <div class="text-center rtl">
              {{ translation.threeSecondBeforeRequest }}
            </div>
          </div>
          <button class="btn btn-primary btn-lg btn3d fullWidth font-weight-bold my-4"
            style="min-height: 60px; width: 80%" @click="showGeolocationRequest">
            {{ translation.allowLocation }}
          </button>
        </div>
      </div>
      <!-- ********************IMAGE COMPTE A REBOURD ********************** -->
      <div v-if="showCounting && permissionStatus == 'prompt'" class="over center">
        <div class="p-3 myModal2" style="
            background-color: #3369bc;
            color: white;
            margin-top: calc(50vh - 240px);
          " @click="showAlertNoName = false">
          <img src="../../../static/img/omerCounting2.gif" class="happyGif" alt="" />
        </div>
      </div>
      <!-- ********************EXPLICATION COMMENT MANUELLEMENT ACCEPTER LA GEOLOCALISATION ********************** -->

      <div v-if="confirmName === true && permissionStatus === 'denied'" class="text-center helpBoxOver">
        <div class="help-box">
          <div class="font-weight-bold text-right mb-1">
            {{ translation.howToActivateLocationTitle }}
          </div>

          <div class="text-right mb-3">
            {{ translation.howToActivateLocation }}
          </div>
          <div class="tabs text-right" style="border-bottom: white 2px solid">
            <button @click="activeTab = 'iphone'" :class="{ active: activeTab === 'iphone' }">
              iPhone
            </button>
            <button @click="activeTab = 'android'" :class="{ active: activeTab === 'android' }">
              Android
            </button>
          </div>

          <div v-if="activeTab === 'iphone'" class="rtl text-right mt-3">
            <p>{{ translation.iphoneStep1 }}</p>
            <p>{{ translation.iphoneStep2 }}</p>
            <p>{{ translation.iphoneStep3 }}</p>
            <div @click="reloadPage" class="btn btn-primary btn-lg btn3d fullWidth font-weight-bold my-4">
              {{ translation.reload }}
            </div>
          </div>

          <div v-if="activeTab === 'android'" class="rtl text-right mt-3">
            <p>{{ translation.androidStep1 }}</p>
            <p>{{ translation.androidStep2 }}</p>
            <p>{{ translation.androidStep3 }}</p>
            <p>{{ translation.androidStep4 }}</p>

            <div @click="reloadPage" class="btn btn-primary btn-lg btn3d fullWidth font-weight-bold my-4">
              {{ translation.reload }}
            </div>
          </div>
        </div>
      </div>
      <!-- ********************POP UP AVANT LE LANCEMENT AVEC PROPOSITION DE TUTO*********************** -->
      <div v-if="confirmName === true && permissionStatus == 'granted'" class="over center">
        <div class="p-3 myModal2 container d-flex">
          <div class="row">
            <div class="px-2 mt-3 col-12 text-center rtl" style="font-family: 'noot', cursive; font-size: 33px">
              {{ translation.nice }} {{ userName }}!
            </div>
            <div class="px-2 mt-3 col-12 text-center">
              {{ translation.beforeStarting }}
            </div>
            <div class="colorBtn btn font-weight-bold position-relative col-5 ml-2 rtl" style="padding-top: 8px"
              @click="showTutorial">
              {{ translation.ok }}
            </div>
            <div class="position-relative text-center col-5" style="margin-top: 37px" @click="startGame">
              {{ translation.skip }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      activeTab: "iphone",
      permissionDenied: false,
      // showiPhoneInstructions: false,
      // showAndroidInstructions: false,
      // safari: false,
      showCounting: false,
      permissionStatus: "",
      showAccessDenied: false,
      beforeGeolocationRequest: true,
      translation: {
        nice: "Well done",
        stamp: "Jeu de piste",
        shortPath: "Parcours court",
        longPath: "Parcours long",
        beware: "Attention!",
        startPoint: "המשחק מתחיל בצומת של ההרחבה",
        letsGoButton: "ON Y EST!",
        beforeStarting:
          "Avant de se lancer, vous pouvez rapidement recevoir quelques explications sur le fonctionnement de l'application.",
        ok: "Ca marche!",
        skip: "Non merci, passer",
        noPassword:
          "Il semblerait que vous avez oublié d'entrer un pseudo... C'est juste pour que vous puissiez voir à quelle place vous avez fini au classement.",
        gotIt: "Ok, j'ai compris",
      },
      confirmName: false,
      navigationName: "eindorfit",
      showAlertNoName: false,
      // groupColorEnglish: "",
      userName: "",
      title: "עין דור",
      userKey: "",
      language: "Français",
    };
  },
  mounted() {
    const savedNav = localStorage.getItem("navigationName");

    // If a different game was in progress, wipe its data and start fresh
    if (savedNav && savedNav !== this.navigationName) {
      const language = localStorage.getItem("language");
      localStorage.clear();
      if (language) localStorage.setItem("language", language);
    }

    // If there is saved progress for THIS navigation, resume it
    const savedPoint = localStorage.getItem("pointNumber");
    if (savedPoint && localStorage.getItem("navigationName") === this.navigationName) {
      this.userName = localStorage.getItem("userName") || "";
      if (localStorage.getItem("language")) {
        this.language = localStorage.getItem("language");
        this.$store.dispatch("switchLanguage", this.language);
      }
      this.userKey = localStorage.getItem("userKey");
      this.$store.dispatch("createNewUser", {
        userName: this.userName,
        navigationName: this.navigationName,
        pointNumber: parseInt(savedPoint),
      });
      this.$store.dispatch("fetchGameData", {
        navigationName: this.navigationName,
        userName: this.userName,
      });
      const pushStartGame = setInterval(() => {
        if (!this.loading) {
          this.$router.push("/play");
          clearInterval(pushStartGame);
        }
      }, 200);
      return; // don't reset showMainScreen — let playV2 restore the saved phase
    }

    // Fresh start: reset phase flags
    localStorage.setItem("showMainScreen", true);
    localStorage.setItem("showPointInformation", false);
    localStorage.setItem("showPickedItem", false);
  },
  computed: {
    lang() {
      return this.translate(this.$store.getters.lang);
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },

  methods: {
    moveToOtherPath() {
      this.$router.push("/einDorFitShort");
    },
    showGeolocationRequest() {
      setTimeout(() => {
        this.showCounting = true;
        this.beforeGeolocationRequest = false;
        setTimeout(() => {
          // this.showCounting = false;
          this.getLocation();
        }, 2000);
      }, 500);
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("position", position);
          this.permissionStatus = "granted";
          console.log("this.permissionStatus", this.permissionStatus);
        },
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.permissionStatus = "denied";
              console.log("this.permissionStatus", this.permissionStatus);
              console.log("User denied the request for Geolocation.");
              break;
            case error.POSITION_UNAVAILABLE:
              console.log("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              console.log("The request to get user location timed out.");
              break;
            case error.UNKNOWN_ERROR:
              console.log("An unknown error occurred.");
              break;
          }
        }
      );
    },

    checkIfName() {
      if (this.userName === "") {
        this.showAlertNoName = true;
      } else {
        this.beforeGeolocationRequest = true;
        if (!navigator.geolocation) {
          alert(
            "La géolocalisation n'est pas prise en charge par ce navigateur."
          );
          return;
        }
        navigator.permissions
          ?.query({ name: "geolocation" })
          .then((result) => {
            if (result.state === "granted") {
              console.log("result.state", result.state);
              this.permissionStatus = "granted";
            } else if (result.state === "denied") {
              console.log("result.state", result.state);
              this.permissionStatus = "denied";
            } else if (result.state === "prompt") {
              this.permissionStatus = "prompt";
            }
          })
          .catch(() => {
            // API Permissions non supportée
            this.getLocation();
          });
        // }, 2000);
        localStorage.setItem("userName", this.userName);
        localStorage.setItem("navigationName", this.navigationName);
        // localStorage.setItem("groupColorEnglish", this.groupColorEnglish);
        this.confirmName = true;
        this.$store.dispatch("createNewUser", {
          userName: this.userName,
          navigationName: this.navigationName,
          // groupColorEnglish: this.groupColorEnglish,
        });
        this.$store.dispatch("fetchGameData", {
          navigationName: this.navigationName,
          userName: this.userName,
          // groupColorEnglish: this.groupColorEnglish,
        });
      }
    },
    translate(lang) {
      switch (lang) {
        case "fr":
          this.translation = {
            nice: "Bravo ",

            stamp: "Jeu de piste",
            shortPath: "Parcours court",
            longPath: "Parcours long",
            beware: "Attention!",
            startPoint: "Le jeu commence à la place de Meyrin Village",
            letsGoButton: "ON Y EST!",
            beforeStarting:
              "Avant de se lancer, vous pouvez rapidement recevoir quelques explications sur le fonctionnement de l'application.",
            ok: "Ca marche!",
            skip: "Non merci, passer",
            noPassword:
              "Il semblerait que vous avez oublié d'entrer un pseudo... C'est juste pour que vous puissiez voir à quelle place vous avez fini au classement.",
            gotIt: "Ok, j'ai compris",
            oups: "אופס",
            howToActivateLocationTitle: "La géolocalisation est désactivée",
            howToActivateLocation:
              "Pour pouvoir jouer, l'application a impérativement besoin d'accéder à votre position.Merci de suivre les instructions ci-dessous pour autoriser la géolocalisation, puis relancez la page.",

            iphoneStep1: "1. Ouvrez Réglages",
            iphoneStep2:
              "2. Allez dans Confidentialité et sécurité > Service de localisation",
            iphoneStep3:
              "3. Activez la localisation pour Safari ou votre navigateur",

            androidStep1:
              "1. Appuyez sur les 3 points ou l’icône menu ≡ dans le navigateur (en haut ou en bas de l’écran)",
            androidStep2:
              "2. Allez dans Paramètres > Paramètres des sites (Chrome) ou Sites et téléchargements > Autorisations de site (Samsung)",
            androidStep3:
              "3. Appuyez sur Localisation, trouvez eifoany.web.app dans la liste des sites bloqués et changez en Autoriser",
            androidStep4: "4. Revenez au jeu et actualisez la page",
            desktopStep1:
              "1. Cliquez sur le cadenas 🔒 à gauche de l’adresse dans la barre d’URL",
            desktopStep2: '2. Choisissez "Autoriser" pour la localisation',
            desktopStep3: "3. Rechargez la page",

            reload: "Relancer la page",
          };
          console.log("french");
          break;
        case "en":
          this.translation = {
            nice: "Well done ",

            stamp: "Jeu de piste",
            shortPath: "Short path",
            longPath: "Long path",
            beware: "Attention!",
            startPoint: "The game begins at the Place of Meyrin Village",
            letsGoButton: "I'M HERE!",
            beforeStarting:
              "Before getting started, you can learn how the app works.",
            ok: "Sure!",
            skip: "No thanks, skip.",
            noPassword:
              "It looks like you forgot to enter a nickname... It's just so you can see where you ended up in the leaderboard.",
            gotIt: "Ok, got it",
            oups: "אופס",
            howToActivateLocationTitle: "Location access is disabled",
            howToActivateLocation:
              "To play the game, the app needs to access your location. Please follow the steps below to enable location access, then refresh the page.",

            iphoneStep1: "1. Open Settings",
            iphoneStep2: "2. Go to Privacy & Security > Location Services",
            iphoneStep3:
              "3. Turn on Location Services and allow it for Safari or your browser",

            androidStep1:
              "1. Tap the 3 dots or menu icon ≡ in your browser (top or bottom of the screen)",
            androidStep2:
              "2. Go to Settings > Site settings (Chrome) or Sites and downloads > Site permissions (Samsung)",
            androidStep3:
              "3. Tap Location, then find eifoany.web.app under Blocked and set it to Allow",
            androidStep4: "4. Return to the game and refresh the page",

            desktopStep1:
              "1. Click the 🔒 padlock on the left of the address bar",
            desktopStep2: '2. Choose "Allow" for location access',
            desktopStep3: "3. Reload the page",

            reload: "Reload the page",
          };
          console.log("english");

          // code block
          break;
        case "he":
          this.translation = {
            nice: "יופי ",
            stamp: "למסלול הקצר",
            shortPath: "מסלול קצר",
            longPath: "מסלול ארוך",
            beware: "שימו לב",
            goToStartPointWaze: "הגיעו לנקודת התחלה",
            startPoint: "המשחק מתחיל ברחבה של המוזאון",
            letsGoButton: "להתחיל",
            beforeStarting: "לפני שמתחילים, תראו איך זה עובד",
            ok: "בטח!",
            skip: "לא תודה",
            noPassword: "נראה ששכת להכניס את שמך",
            allowLocation: "הבנתי, אאשר מיקום",
            gotIt: "הבנתי",

            oups: "אופס",
            threeSecondBeforeRequest:
              "3 שניות אחרי לחיצה על הכפתור מטה, יפתח חלון בו תוכלו לאשר מיקום. מאוד חשוב לאשר, אחרת לא תוכלו לשחק.  ",
            doItManualy: "משהו לא הסתדר, צריך לעשות את זה ידני.",
            howToActivateLocationTitle: "שירותי המיקום כבויים",
            howToActivateLocation:
              "כדי לשחק, האפליקציה חייבת לקבל את המיקום שלך. אנא עקוב אחר ההוראות למטה כדי לאשר גישה לשירותי המיקום ואז רענן את הדף",

            iphoneStep1: "1. פתחו את ההגדרות",
            iphoneStep2: "2. עברו אל פרטיות ואבטחה > שירותי מיקום",
            iphoneStep3:
              "3. הפעילו את שירותי המיקום ואשרו עבור Safari או הדפדפן שלכם",

            androidStep1:
              "1. לחצו על שלוש הנקודות או על תפריט ≡ בדפדפן (למעלה או למטה במסך)",
            androidStep2:
              "2. עברו אל הגדרות > הגדרות אתר (ב-Chrome) או אתרים והורדות > הרשאות אתר (ב-Samsung)",
            androidStep3:
              "3. לחצו על מיקום, חפשו את eifoany.web.app ברשימת האתרים החסומים ושנו לאפשר",
            androidStep4: "4. חזרו למשחק ורעננו את הדף",

            desktopStep1: "1. לחצו על הסמל 🔒 בצד שמאל של שורת הכתובת",
            desktopStep2: '2. בחרו "אפשר" עבור שירותי מיקום',
            desktopStep3: "3. רעננו את העמוד",

            reload: "רענן את הדף",
          };
          // code block
          break;
        default:
        // code block
      }
    },
    startGame() {
      this.$router.push("/play");
    },
    showTutorial() {
      localStorage.setItem("inGameTutorial", "true");
      localStorage.setItem("tutorialScreensWanted", "true");
      this.$router.push("/play");
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
    reloadPage() {
      window.location.reload();
    },
    // switchLangToFrench() {
    //   this.$store.dispatch("switchLangToFrench");
    // },
    // switchLangToEnglish() {
    //   this.$store.dispatch("switchLangToEnglish");
    // },
  },
};
</script>

<style scoped>
.help-box {
  padding: 15px;
  background-color: #5286d5;
  border-radius: 8px;
  color: white;
  height: auto;
  justify-content: center;
}

.help-box button {
  background-color: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 5px 5px 0px 0px;
  border-bottom: none;
  top: 3px;
  position: relative;
  /* z-index: 5; */
  margin: 0px 15px;
  width: 109px;
}

.help-box button.active {
  border-bottom: 4px solid #5286d5;
}

/* .help-box button:hover {
  background-color: #e68900;
} */
.wazeImage {
  height: 50px;
  position: absolute;
  right: 0px;
  top: -6px;
}

.blur {
  backdrop-filter: blur(10px);
}

.logoBar {
  height: 10%;
  background: #3369bc;
  position: relative;
  top: -7px;
  left: 0px;
  width: 100vw;
  max-width: 590px;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 101;
}

.logo img {
  height: 57px;
}

.startText {
  color: white;
  position: absolute;
  bottom: 10px;
  font-weight: bold;
  text-align: center;
}

.bottomBar {
  height: 10%;
  background: #3369bc;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100vw;
  max-width: 590px;
  left: 50%;
  transform: translate(-50%, 0%);
}

.startButton {
  height: 80px;
  width: 80px;
  background: white;
  color: #3369bc;
  position: relative;
  bottom: 47px;
  border-radius: 100%;
}

.btn3d {
  position: relative;
  top: -6px;
  border: 0;
  transition: all 40ms linear;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
}

.btn3d:active:focus,
.btn3d:focus:hover,
.btn3d:focus {
  -moz-outline-style: none;
  outline: medium none;
}

.btn3d:active,
.btn3d.active {
  top: 2px;
}

.btn3d.btn-primary {
  /* box-shadow: 0 0 0 1px #417fbd inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #4d5bbe, 0 8px 8px 1px rgba(0, 0, 0, 0.5); */
  box-shadow: 0 0 0 1px #153c77 inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
    0 8px 0 0 #153c77, 0 8px 8px 1px rgb(0 0 0 / 50%);
  /* background-color: #4274d7; */
  background-color: #2059af;
}

.btn3d.btn-primary:active,
.btn3d.btn-primary.active {
  box-shadow: 0 0 0 1px #153c77 inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 1px 3px 1px rgba(0, 0, 0, 0.3);
  background-color: #2059af;
}

.happyGif {
  height: 250px;
  width: 250px;
  bottom: 5px;
  left: 1px;
  position: relative;
  border: 2px solid white;
  border-radius: 100%;
}

.beware {
  font-family: noot, cursive;
  font-size: 30px;
  position: relative;
  color: yellow;
}

.rtl {
  direction: rtl;
}

.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
  border-radius: 36px;
  /* height: 56px; */
  color: white;
}

/* #stampGame {
  color: #3369bc;
  font-weight: 700;
  border: 0.25rem solid #3369bc;
  display: inline-block;
  padding: 0.25rem 1rem;
  text-transform: uppercase;
  border-radius: 1rem;
  font-family: "Courier";
  -webkit-mask-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/8399/grunge.png);
  -webkit-mask-size: 944px 604px;
  mix-blend-mode: hard-light;
  position: absolute;
  top: 34%;
  -webkit-transform: rotate(20deg);
  transform: rotate(-10deg);
  z-index: 3;
  font-size: 23px;
  width: 225px;
  -webkit-animation-name: stamp;
  animation-name: stamp;
  -webkit-animation-duration: 2.2s;
  animation-duration: 2.2s;
  margin-left: 81px;
} */
#stampGame {
  font-family: VarelaRound;
  position: relative;
  font-size: 21px;
  padding: 8px 25px;
  font-weight: bold;
  color: white;
  -webkit-background-clip: text;
  background-clip: text;
  background: #3369bc;
  border-radius: 50px;
  width: auto;
}

.myModal {
  display: block;
  margin: 0px auto;
}

#titleMainPage {
  font-family: VarelaRound;
  position: relative;
  font-size: 80px;
  color: #3369bc;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: reveal 1000ms ease-in-out forwards 200ms,
    glow 2500ms linear infinite 2000ms;
}

.subTitle {
  position: relative;
  bottom: 50px;
  right: 74px;
  font-family: VarelaRound;
  position: relative;
  font-size: 40px;
  color: #ffffff;
  border: solid 2px;
  border-radius: 37px;
  -webkit-transform: rotate(45deg);
  transform: rotate(13deg);
}

.main {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  top: 52px;
  position: relative;
}

.moveTitle {
  animation-duration: 3s;
  animation-name: slidein;
}

.title {
  font-family: "Righteous", cursive;
  font-size: 70px;
  color: #cf1110;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.ltr {
  direction: ltr;
  text-align: left;
}

.myModal2 {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  background-color: #3369bc;
  color: white;
  border: solid 3px white;
}

.over {
  position: fixed;
  top: 0px;
  font-size: 18px;
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  background: url("../../../static/img/einDorFit.jpg") no-repeat center center;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 2;
}

.helpBoxOver {
  backdrop-filter: blur(5px);
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  top: 0px;
  font-size: 18px;
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  /* background: url(/img/einDorFit.c28154e4.jpg) no-repeat center center; */
  background-size: cover;
  /* background-color: rgba(0, 0, 0, 0.9); */
  justify-content: center;
  align-content: center;
}

.colorBtn {
  border-radius: 36px;
  color: #3369bc;
  margin: 0px auto;
  margin-top: 30px;
  background-color: white;
  padding-top: 14px;
}

.center {
  display: block;
  margin: 0px auto;
}

@keyframes reveal {
  80% {
    letter-spacing: 8px;
  }

  100% {
    background-size: 300% 300%;
  }
}

@keyframes glow {
  40% {
    text-shadow: 0 0 8px #fcfdff;
  }
}

@keyframes stamp {
  0% {
    opacity: 0;
  }

  70% {
    opacity: 0;
  }

  85% {
    opacity: 0;
  }

  93% {
    opacity: 0;
  }

  94% {
    opacity: 0.5;
    transform-origin: 50% 50%;
    transform: scale(4);
    transition: all 0.1s cubic-bezier(0.6, 0.04, 0.98, 0.335);
  }

  100% {
    opacity: 1;
    transform: rotate(-20deg) scale(1);
  }
}

@keyframes animate {
  0% {
    opacity: 0;
    background-position: -500%;
    background-size: 80%;
  }

  20% {
    opacity: 1;
    background-position: 400%;
    background-size: 80%;
  }

  40% {
    background-position: -200%;
    background-size: 80%;
  }

  60% {
    background-position: 0%;
    background-size: 80%;
  }

  80% {
    background-position: 0%;
    background-size: 100%;
  }

  100% {
    background-position: 0%;
  }
}

@keyframes appear {
  0% {
    opacity: 0;
  }

  30%,
  70% {
    opacity: 0;
  }

  90% {
    opacity: 1;
  }

  93% {
    opacity: 0.5;
  }

  95% {
    opacity: 1;
    transform: scale(1.05);
  }

  98% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@keyframes slidein {
  0% {
    margin-left: 120vw;
  }

  72% {
    margin-left: 120vw;
  }

  98% {
    margin-left: 3%;
  }

  to {
    margin-left: 0%;
  }
}

@font-face {
  font-family: noot;
  src: url(../../../static/fonts/Noot/noot-aj.woff);
}

@font-face {
  font-family: VarelaRound;
  src: url(../../../static/fonts/VarelaRound-Regular.ttf);
}
</style>
